<script>
import { useEnrollmentStore } from "@/stores/access/enrollment-store.js";
import { useAuthStore } from "@/stores/auth-store";
import { useSharedStore } from "@/stores/shared-store";
import CourseStudentFilter from "@/components/CustomComponent/modal/course-student-filter.vue";
import CourseCard from "@/components/CustomComponent/shared/CourseCard.vue";

export default {
  components: {
    CourseStudentFilter,
    CourseCard,
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 6,
    };
  },
  computed: {
    enrollmentStore() {
      return useEnrollmentStore();
    },
    authStore() {
      return useAuthStore();
    },
    sharedStore() {
      return useSharedStore();
    },
    paginatedEnrollment() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.enrollmentStore.filteredEnrollmentCourses.slice(start, end);
    },
    totalPages() {
      return Math.ceil(
         this.enrollmentStore.filteredEnrollmentCourses.length / this.itemsPerPage
      );
    },
  },
  created() {
    this.enrollmentStore.fetchEnrollmentStudentList(
      this.authStore.currentUser.id
    );
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  },
};
</script>

<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">Enrolled Courses</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Enrolled Courses
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <!-- profile box -->
      <student-header></student-header>
      <!-- profile box -->
      <div class="row">
        <!-- sidebar -->
        <student-sidebar></student-sidebar>
        <!-- sidebar -->
        <div class="col-lg-9">
          <div
            class="page-title d-flex flex-wrap gap-3 align-items-center justify-content-between"
          >
            <h5>Enrolled Courses</h5>
            <div class="tab-list">
              <button
                class="btn btn-outline-secondary d-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#filterStudentCourseModal"
              >
                <i class="feather-filter me-2 text-end"></i>Filters
              </button>
            </div>
          </div>
          <div class="tab-content">
            <div
              class="tab-pane fade active show"
              id="enroll-courses"
              role="tabpanel"
            >
              <div class="row">
                <div
                  class="col-xl-4 col-md-6"
                  v-for="(item, index) in paginatedEnrollment"
                  :key="item.courseID?.course_id || index"
                >
                  <CourseCard :course="item.courseID" :status="item.status" />
                </div>
              </div>
            </div>
          </div>
          <!-- /pagination -->
          <div class="row align-items-center mt-2">
            <div class="col-md-2">
              <p class="pagination-text">
                Page {{ currentPage }} of {{ totalPages }}
              </p>
            </div>
            <div class="col-md-10">
              <ul
                class="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0"
              >
                <li
                  class="page-item prev"
                  :class="{ disabled: currentPage === 1 }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    tabindex="-1"
                    @click="prevPage"
                    ><i class="fas fa-angle-left"></i
                  ></a>
                </li>
                <li
                  v-for="page in totalPages"
                  :key="page"
                  class="page-item"
                  :class="{ active: currentPage === page }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    @click="goToPage(page)"
                    >{{ page }}</a
                  >
                </li>
                <li
                  class="page-item next"
                  :class="{ disabled: currentPage === totalPages }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    @click="nextPage"
                  >
                    <i class="fas fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- /pagination -->
        </div>
      </div>
    </div>
  </div>
  <CourseStudentFilter />
  <!-- Footer -->
  <!-- <footer-two></footer-two> -->
  <!-- /Footer -->
</template>
